export const PASSWORD_STRENGTHS = {
  WEAK: 'weak',
  MODERATE: 'moderate',
  STRONG: 'strong',
  NONE: 'none'
};